module.exports = __webpack_public_path__ + "img/instruction_vieworder_2d_mobile.cb16fc00.png";